import React from "react";
import { FormFull } from "form-full";
import { masks, validations } from "../../../utils";
import Styles from "../styles/Styles";
import { Grid } from "@material-ui/core";
import { Input, InputTags } from "../../../components/index";
import { Label } from "../../../components/inputs/Input";

function Filters({ onSubmit, loading, placeList }) {

    
    return (
        <FormFull onSubmit={(data) => onSubmit(data)}>
            <Grid container spacing={1}>
                <Grid item xs={12} md={6} lg={2}>
                    <Input 
                        name="responsibleName" 
                        label="Nome Prestador" 
                        placeholder="Nome Prestador" 
                    />
                </Grid>
                <Grid container item xs={12} md={6} lg={2}>
                    <Label>Imóvel</Label>
                    <InputTags
                        readOnly={false}
                        name="placeName"
                        options={placeList ? placeList : []}
                        defaultValue={null}
                        multiple
                    />
                </Grid>
                <Grid item xs={12} md={6} lg={3}>
                    <Input 
                        name="document" 
                        label="CPF OU CNPJ" 
                        mask={(e) => e.length > 14 ? masks.CNPJ(e) : masks.CPF(e)}
                        validation={validations.validateCNPJandCPF}
                        maskToSubmit={masks.removeNumberMask}
                        placeholder="000.000.000-00 ou 00.000.000/0000-00"
                    />
                </Grid>
                <Grid item xs={12} md={6} lg={2}>
                    <Input 
                        name="empresa" 
                        label="Empresa" 
                        placeholder="Empresa" 
                    />
                </Grid>
                {/* <Grid item xs={12} md={6} lg={2}>
                    <Input 
                        name="cnpj" 
                        label="CNPJ Empresa" 
                        mask={masks.CNPJ}
                        validation={validations.validateCNPJ}
                        maskToSubmit={masks.removeNumberMask}
                        placeholder="00.000.000/0000-00"
                    />
                </Grid> */}
                <Grid item xs={12} md={6} lg={3}>
                    <Input 
                        name="email" 
                        label="E-mail representante" 
                        placeholder="E-mail Representante"
                    />
                </Grid>
            </Grid>
            <Styles.ButtonContainer>
                <Styles.Clear
                    loading={loading}
                    disabled={loading}
                    fullWidth={false}
                    action="clear"
                >
                    Limpar
                </Styles.Clear>
                <Styles.Submit
                    loading={loading}
                    disabled={loading}
                    fullWidth={false}
                    action="submit"
                    style={{ borderRadius: 28 }}
                >
                    Aplicar Filtros
                </Styles.Submit>
            </Styles.ButtonContainer>
        </FormFull>
    );
}

export default Filters;
